import _asyncToGenerator from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("确定");

import { computed, reactive, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { addPrizeCount } from '@/request';
import PrizeValidFormItem from './PrizeValidFormItem.vue';
export default {
  name: 'AddPrizeCountModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const formRef = ref();
    const saving = ref(false);
    const form = reactive({
      addNumber: undefined,
      validType: 1,
      validEndDate: ''
    });
    const rules = {
      addNumber: [{
        required: true,
        message: '请填写奖励数量',
        trigger: 'blur'
      }, {
        validator: (_rule, value, callback) => {
          if (!value || value <= 0) {
            callback(new Error('奖励数量必须大于0'));
            return;
          }

          callback();
        },
        trigger: 'blur'
      }],
      validType: [{
        validator: (_rule, value, callback) => {
          if (!value) {
            callback(new Error('请选择效期'));
            return;
          }

          if (value === 5 && !form.validEndDate) {
            callback(new Error('请选择自定义截止日期'));
            return;
          }

          callback();
        },
        trigger: 'change'
      }]
    };
    watch(() => props.modelValue, val => {
      if (val) {
        var _formRef$value;

        form.addNumber = undefined;
        form.validType = 1;
        form.validEndDate = '';
        (_formRef$value = formRef.value) === null || _formRef$value === void 0 ? void 0 : _formRef$value.clearValidate();
      }
    });

    function handleConfirm() {
      return _handleConfirm.apply(this, arguments);
    }

    function _handleConfirm() {
      _handleConfirm = _asyncToGenerator(function* () {
        if (saving.value) {
          return;
        }

        try {
          var _formRef$value2;

          yield (_formRef$value2 = formRef.value) === null || _formRef$value2 === void 0 ? void 0 : _formRef$value2.validate();
        } catch (_unused) {
          return;
        }

        saving.value = true;
        addPrizeCount({
          merchandiseCansaleId: props.row.merchandiseCansaleId,
          addNumber: form.addNumber,
          validType: form.validType,
          validEndDate: form.validType === 5 ? form.validEndDate : undefined,
          __repeat: true,
          __warn: true
        }).then(data => {
          if (data.success) {
            ElMessage.success(data.msg || '操作成功');
            visible.value = false;
            emit('success');
          }
        }).finally(() => {
          saving.value = false;
        });
      });
      return _handleConfirm.apply(this, arguments);
    }

    return (_ctx, _cache) => {
      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "新增数量",
        width: "520px",
        "destroy-on-close": ""
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          loading: saving.value,
          onClick: handleConfirm
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }, 8, ["loading"])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form,
          rules: rules,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "新增数量",
            prop: "addNumber"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: form.addNumber,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.addNumber = $event),
              min: 1,
              max: 99999,
              precision: 0,
              controls: true,
              style: {
                "width": "200px"
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "效期",
            prop: "validType",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(PrizeValidFormItem, {
              "valid-type": form.validType,
              "onUpdate:valid-type": _cache[1] || (_cache[1] = $event => form.validType = $event),
              "valid-end-date": form.validEndDate,
              "onUpdate:valid-end-date": _cache[2] || (_cache[2] = $event => form.validEndDate = $event)
            }, null, 8, ["valid-type", "valid-end-date"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};